import { MooringBeforeDeparture } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const MOORING_BEFORE_DEPARTURE_DATA_TAG = 'MooringBeforeDeparture';
export default class MooringBeforeDepartureParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_BEFORE_DEPARTURE, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_BEFORE_DEPARTURE, MOORING_BEFORE_DEPARTURE_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            freeText: 'freeText',
            statementForShipSafetyAndIntegrity: 'statementForShipSafetyAndIntegrity',
        };
    }
    createData(props, record) {
        const data = new MooringBeforeDeparture(props.port, props.freeText, props.statementForShipSafetyAndIntegrity);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
//# sourceMappingURL=MooringBeforeDepartureParser.js.map